import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import icon from '../../images/icon/magic.svg';
import gImg1 from '../../images/logo-fff.png';
import Seo from '../../components/Seo';

const TermsConditions = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return (
        <Fragment>
            <Seo 
                title={`${t('terms.title')} | Orbitronix`}
                description={t('terms.agreement.body')}
                url={`/${lang || 'en'}/terms-conditions`}
            />
            <Layout>
                {/* Hero Section with Animation */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="page-title pt-150 pos-rel bg_img"
                >
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div 
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.3 }}
                                        className="page-title-box"
                                    >
                                        <motion.span 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5 }}
                                            className="sub-title"
                                        >
                                            <img src={icon} alt="" /> {t('terms.title')}
                                        </motion.span>
                                        <motion.h2 
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="title"
                                        >
                                            {t('terms.heading')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                                <div className="col-lg-3 mt-30 justify-content-center d-flex">
                                    <motion.div 
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.9, duration: 0.5 }}
                                        className="sd-right-img pos-rel"
                                    >
                                        <img src={gImg1} alt="" />
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Content Section with Animation */}
                <motion.section 
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="terms&conditions-section pt-85 pb-85 cp-det-bg"
                >
                    <div className="container">
                        <div className="terms-section_inner">
                            <div className="row">
                                <div className="col-lg-12">
                                    <motion.div 
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.7, duration: 0.6 }}
                                        className="item-details-widget" 
                                        style={{ padding: '50px 50px 60px 50px' }}
                                    >
                                        <p className="mb-4" style={{ opacity: 0.8, fontStyle: 'italic' }}>{t('terms.lastUpdated')}</p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }} className="mb-20">
                                            1. {t('terms.agreement.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9 }} className="mb-30">
                                            {t('terms.agreement.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0 }} className="mb-20">
                                            2. {t('terms.services.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1 }} className="mb-30">
                                            {t('terms.services.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }} className="mb-20">
                                            3. {t('terms.intellectual.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.3 }} className="mb-30">
                                            {t('terms.intellectual.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4 }} className="mb-20">
                                            4. {t('terms.liability.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }} className="mb-30">
                                            {t('terms.liability.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.6 }} className="mb-20">
                                            5. {t('terms.law.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.7 }}>
                                            {t('terms.law.body')}
                                        </motion.p>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default TermsConditions;
